import { createInfiniteRepository } from "shared/api/infinite-repository";
import { graphql } from "src/gql";
import { singleton } from "tsyringe";

@singleton()
export class TemplateSearchRepository extends createInfiniteRepository(
    graphql(`
        query TempalteSearchRepository($offset: Int!, $limit: Int!, $groupId: UUID, $search: TemplatesSearchParametersInput) {
            templates(offset: $offset, limit: $limit, ownerId: $groupId, search: $search) {
                ...TemplateLike
            }
        }
    `),
    {
        page: (doc) => doc.templates,
    },
) {}
